import Vue from 'vue'
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue'

Vue.component(FeatherIcon.name, FeatherIcon)
const AppTooltip = () => import('@core/components/tooltip/AppTooltip.vue')
Vue.component(AppTooltip.name, AppTooltip)

const NoDataAvailable = () => import('@/views/users/shared/NoDataAvailable.vue')
Vue.component(NoDataAvailable.name, NoDataAvailable)
